import "../style/blog/Blog.scss";

import img1 from "../../assets/blog/robert-katzki-jbtfM0XBeRc-unsplash.png";
import img2 from "../../assets/blog/steve-harvey-U4wcrDteZ2Y-unsplash.jpg";
import img3 from "../../assets/blog/agatha-depine-dJL6L7YFh5c-unsplash.jpg";
import img4 from "../../assets/blog/christopher-gower-m_HRfLhgABo-unsplash.jpg";
import img5 from "../../assets/blog/rod-long-eWc6BKWduMQ-unsplash.png";

let bpl_data = [
  {
    id: 1,
    title: "سفر به مریخ،خیلی دور، خیلی نزدیک",
    subject: "نجوم",
  },
  {
    id: 2,
    title: "خلاقانه‌ترین متدهای آموزشی",
    subject: "آموزش",
  },
  {
    id: 3,
    title: "چرا دسترسی آزاد به اطلاعات مهم و ضروری است؟",
    subject: "اجتماعی",
  },
  {
    id: 4,
    title: "آشنایی با تفکر خارج از چارچوب",
    subject: "خلاقیت",
  },
  {
    id: 5,
    title: "در ستایش علم ...",
    subject: "علم",
  },
];

let main_data = [
  {
    id: 1,
    img: img3,
    subject: "تاریخ",
    title: "قدیمی‌ترین مدرسه جهان",
    subtitle:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، ",
  },
  {
    id: 2,
    img: img4,
    subject: "تکنولوژی",
    title: "محبوب‌ترین زبان‌های برنامه‌نویس 2021",
    subtitle:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، ",
  },
  {
    id: 3,
    img: img5,
    subject: "خلاقیت",
    title: "خلاقیت در معماری",
    subtitle:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، ",
  },
];

let filter_btns_data = [
  {
    id: 1,
    btn: "همه موضوعات",
    isActive: true,
  },
  {
    id: 2,
    btn: "استراتژی",
    isActive: false,
  },
  {
    id: 3,
    btn: "کتاب",
    isActive: false,
  },
  {
    id: 4,
    btn: "علم",
    isActive: false,
  },
  {
    id: 5,
    btn: "فلسفه",
    isActive: false,
  },
  {
    id: 6,
    btn: "اقتصاد",
    isActive: false,
  },
  {
    id: 7,
    btn: "خلاقیت",
    isActive: false,
  },
  {
    id: 8,
    btn: "تاریخ",
    isActive: false,
  },
  {
    id: 9,
    btn: "تکنولوژی",
    isActive: false,
  },
  {
    id: 10,
    btn: "آموزش",
    isActive: false,
  },
];

const Blog = () => {
  return (
    <div className="Blog">
      <div className="Blog-title">وبلاگ</div>
      <div className="Blog-part1">
        <div className="Blog-part1-right">
          <div className="Blog-part1-right-img-container">
            <img
              className="Blog-part1-right-img-container-img"
              src={img1}
              alt="blog-img"
            />
          </div>
          <div className="Blog-part1-right-small-text">کتاب</div>
          <div className="Blog-part1-right-title">
            بهترین کتاب‌ها برای شروع فلسفه
          </div>
          <div className="Blog-part1-right-subtitle">
            شاید شما هم جزو افرادی باشید که دوست دارند که فلسفه رو شروع کنند ولی
            نمیدونید باید ار کجا شروع کنید که دلسرد نشوید. در این مطلب به پنج
            کتاب درباره فلسفه می‌پردازیم که برای شروع فلسفه مناسب هستند.
          </div>
          <div className="Blog-part1-right-writer-box">
            <div className="Blog-part1-right-writer-box-avatar">
              <img src={img2} alt="writer-avatar" />
            </div>
            <div className="Blog-part1-right-writer-box-name">
              {" "}
              نوشته شده توسط علی بندری
            </div>
          </div>
        </div>
        <div className="Blog-part1-left">
          {bpl_data.map((item) => (
            <div key={item.id} className="Blog-part1-left-item">
              <div className="Blog-part1-left-item-title">{item.title}</div>
              <div className="Blog-part1-left-item-subject">{item.subject}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="Blog-part2">
        {main_data.map((item, index) => (
          <div
            style={
              (index + 1) % 3 === 0
                ? { marginLeft: "0px" }
                : { marginLeft: "5%" }
            }
            key={item.id}
            className="Blog-part2-item"
          >
            <div className="Blog-part2-item-img-container">
              <img src={item.img} alt="item-img" />
            </div>
            <div className="Blog-part2-item-subject">{item.subject}</div>
            <div className="Blog-part2-item-title">{item.title}</div>
            <div className="Blog-part2-item-subtitle">{item.subtitle}</div>
          </div>
        ))}
      </div>
      <div className="Blog-more-btn">مشاهده بیشتر</div>
      <div className="Blog-filter-btns">
        {filter_btns_data.map((item, i) => (
          <div
            key={i}
            style={
              item.isActive
                ? { backgroundColor: "#2E81E8", color: "#FFF" }
                : null
            }
            className="Blog-filter-btns-item"
          >
            {item.btn}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
